// ClipboardController - copy content to the clipboard
//
// @example
//  <div data-controller="clipboard">
//    <button data-action="click->clipboard#copyTo" data-clipboard-content-param="t0k3n">
//      Copy Token
//    </button>
//  </div>

import {Controller} from "stimulus";

export default class extends Controller {
  copyTo(event) {
    event.stopPropagation();

    if (event.params.contentType == "text/html") {
      const text_blob = Promise.resolve(new Blob([event.params.content], {type: event.params.contentType}));
      const clipboardItemInput = new ClipboardItem(
        {[event.params.contentType]: text_blob},
        {presentationStyle: "unspecified"});
      navigator.clipboard.write([clipboardItemInput]);
    } else {
      navigator.clipboard.writeText(event.params.content);
    }

    this.showUserFeedback();
  }

  showUserFeedback() {
    const {opacity} = window.getComputedStyle(this.element);

    this.element.style.opacity = 0.5;
    this.element.style.pointerEvents = "none";

    const banner = document.createElement("div");

    banner.setAttribute("style", "position: fixed; top: -100%; left: 0; right: 0; white-space: nowrap; background-color: #d9edf7; color: #31708f; display: flex; align-items: center; justify-content: center; font-size: 15px; height: 40px; pointer-events: none; z-index: 9999; transition: all 250ms ease;");
    banner.innerText = "Copied to clipboard ✓";
    document.body.appendChild(banner);

    // Animate banner
    setTimeout(() => {
      banner.style.top = 0;
    });

    setTimeout(() => {
      this.element.style.pointerEvents = "all";
      this.element.style.opacity = opacity;
      banner.remove();
    }, 2000);
  }
}
